import { render, staticRenderFns } from "./procureInfo.vue?vue&type=template&id=0c019b2e&scoped=true&"
import script from "./procureInfo.vue?vue&type=script&lang=js&"
export * from "./procureInfo.vue?vue&type=script&lang=js&"
import style0 from "./procureInfo.vue?vue&type=style&index=0&id=0c019b2e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c019b2e",
  null
  
)

export default component.exports